
import _ from 'lodash';

import type { ChartPortData } from '../Widgets/Things/Charts/ChartsJsonScheme';
import { isDefined, IsNullOrWhiteSpace, isStringEmpty } from '@Utils/Micro';
import { ReduxThingState, StateStatus } from '@API/WebNodeTypes';

// ---------------------------------------------------------------------------------------------
export function tooltipLabelCallback(tooltipItem, data, prefix, postfix) {
    let label = '';
    if (!isDefined(tooltipItem) || !isDefined(data))
        return label;

    // Add legend label (if any).
    const legendLabel = data.labels[tooltipItem.index];
    if (!isStringEmpty(legendLabel))
        label += legendLabel + ': ';

    // Add prefix (if any).
    if (!isStringEmpty(prefix))
        label += prefix;

    // Add data point.
    label += data
        .datasets[tooltipItem.datasetIndex]
        .data[tooltipItem.index];

    // Add postfix (if any).
    if (!isStringEmpty(postfix))
        label += postfix;

    return label;
}
// ---------------------------------------------------------------------------------------------
export function handleExcelDownloadClick(
    filename: string,
    reduxState: ReduxThingState,
    portKey: string,
    defaultValues: { [key: string]: any }
) {
    // Is redux state defined?
    if (!isDefined(reduxState))
        return;

    // Get port.
    const p = reduxState.PortStates[portKey];
    if (!isDefined(p))
        return;

    if (p.LastStateStatus == StateStatus.Valid) {
        // Download excel using current state.
        downloadExcel(p.State, filename);
    }
    else if (p.LastStateStatus == StateStatus.NoData) {

        if (!isDefined(defaultValues)) return;

        // Get default value.
        const dv = defaultValues[portKey];
        if (!isDefined(dv))
            return;

        // Download excel using default value.
        downloadExcel(dv, filename);
    }
}
// ------------------------------------------------------------------------------------------------
export function downloadExcel(data: ChartPortData, filename: string) {
    if (_.isEmpty(data)) return;
    let aoa = [];

    // Add header row.
    aoa[0] = [];
    aoa[0][0] = 'Labels';
    _.forEach(data.datasets, (d, i) =>
        aoa[0][i + 1] = d.label);

    // Are there any labels?
    if (_.isArray(data.labels)) {
        _.forEach(data.labels, (l, i) => {
            // Set first cell with label.
            aoa[i + 1] = [];
            aoa[i + 1][0] = l;

            // Add data to next cells.
            _.forEach(data.datasets, (d, j) => {
                const _data = d.data[i];
                aoa[i + 1][j + 1] = _.isObject(_data)
                    ? _.join(_.values(_data), ', ') : _data;
            });
        });
    }
    else {
        _.forEach(data.datasets, (ds, i) => {
            // Add only data without label.
            _.forEach(ds.data, (d, j) => {
                if (!isDefined(aoa[j + 1]))
                    aoa[j + 1] = [];

                aoa[j + 1][i + 1] = _.isObject(d)
                    ? _.join(_.values(d), ', ') : d;
            });
        });
    }

    // Add extension to filename.
    filename = IsNullOrWhiteSpace(filename)
        ? 'Chart.xlsx'
        : filename + '.xlsx';

    import('xlsx').then(xlsx => {
        // Create worksheet and workbook.
        const ws = xlsx.utils.aoa_to_sheet(aoa);
        const wb = xlsx.utils.book_new();

        // Add worksheet to workbook and download it.
        xlsx.utils.book_append_sheet(wb, ws, 'Data');
        xlsx.writeFile(wb, filename);
    });
}
// ------------------------------------------------------------------------------------------------